import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

// permission judge function
function hasPermission(perms, permissions) {
  if (perms.indexOf('*') >= 0) return true // admin permission passed directly
  if (!permissions) return true
  return perms.some(perm => permissions.indexOf(perm) >= 0)
}

const whiteList = ['/login','/register','/sharedetail']// no redirect whitelist
// 路由拦截器

/**
 * from 从哪里来，to 到哪里去，next()
 */
router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar
  if (getToken()) { // determine if there has token
  
    /* has token*/
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } 
    else if(whiteList.indexOf(to.path) !== -1){
      next();
    }else {
       // 判断当前用户是否有角色信息信息
      if (store.getters.roles.length === 0) { 
        store.dispatch('GetUserInfo').then(res => { // 拉取user_info
          const perms = res.permissions||[];// note: perms must be a array! such as: ['GET /aaa','POST /bbb']
        
          store.dispatch('permission/GenerateRoutes').then(accessRoutes => { // 根据perms权限生成可访问的路由表
            for(let i=0;i<accessRoutes.length;i++){
              const element=accessRoutes[i];
              router.addRoute(element) // 动态添加可访问路由表
            }
      
            next({ ...to, replace: true }) // hack方法  ,set the replace: true so the navigation will not leave a history record
          })
        }).catch((err) => {
          
          store.dispatch('FedLogOut').then(() => {
           
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        // 没有动态改变权限的需求可直接next() 删除下方权限判断 ↓
       
        if (hasPermission(store.getters.permissions, to.meta.perms)) {
          next()
        } else {
          next({ path: '/401', replace: true, query: { noGoBack: true }})
        }
        // 可删 ↑
      }
    }
  } else {
   
    /* has no token*/
    if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
      console.log(whiteList);
      next()
    } else {
      next(`/login?redirect=${to.path}`) // 到登录页, 并带有重定向的地址
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
    next()
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})
